import {
  ButtonProps,
  ButtonType,
  ButtonWidget
} from '@tableau/widgets';
import React from 'react';

import { imgPath } from '~src/commonInfra/utils/ImgUrl';

import { Messages } from '../../../codegen/Localize';
import { SpaceHeaderStyles } from './SpaceHeaderStyles';

const ICON_PATH = imgPath('data_prep_info.svg');
const ACTIVE_ICON_PATH = imgPath('data_prep_info_active.svg');

const getDetailButtonContent: ButtonProps['getContent'] = (state) => {
  const showActiveIcon = state.hover || state.active || state.focus;
  return (
    <img
      className={SpaceHeaderStyles.HeaderButtonImage}
      src={showActiveIcon ? ACTIVE_ICON_PATH : ICON_PATH}
      alt=""
    />
  );
};

export interface DetailButtonProps {
  readonly testId: string;
}

export function DetailButton(props: DetailButtonProps & React.ButtonHTMLAttributes<HTMLButtonElement>) {
  const { testId, ...buttonProps } = props;
  return (
    <ButtonWidget
      {...buttonProps as ButtonProps}
      buttonType={ButtonType.LowEmphasis}
      getContent={getDetailButtonContent}
      title={Messages.details()}
      testId={`${testId}-detail-button`}
      style={SpaceHeaderStyles.IconButtonStyleOverrides}
    />
  );
}
